export var BILL_DRAWER_DEFAULT_WIDTH = 1030;
export var BILL_DRAWER_MIN_WIDTH_IN_CN = 680;
export var BILL_DRAWER_MIN_WIDTH_IN_EN = 778;
var BILL_DRAWER_WIDTH_STORAGE_KEY = 'billDrawerWidthKey';
export var BILL_CONTENT_PART_MIN_WIDTH = 384;
var FLOW_PART_MIN_RESIZE_WIDTH = 300;
var FLOW_PART_MAX_RESIZE_WIDTH = 500;
var FLOW_PART_LIST_MODE_DEFAULT_WIDTH = 360;
var FLOW_PART_TABLE_MODE_DEFAULT_WIDTH = 320;
var FLOW_PART_CREATE_STATE_DEFAULT_WIDTH = 400;
export var listenerToDrawerResize = function (callback) {
    var handleDrawerWidthResize = function (e) {
        var width = e.detail.width;
        billDrawerConfig.width = width;
        callback === null || callback === void 0 ? void 0 : callback(width);
    };
    window.addEventListener('drawerWidthResize', handleDrawerWidthResize);
    return function () {
        window.removeEventListener('drawerWidthResize', handleDrawerWidthResize);
    };
};
export var billDrawerConfig = {
    get minWidth() {
        return i18n.currentLocale === 'zh-CN' ? BILL_DRAWER_MIN_WIDTH_IN_CN : BILL_DRAWER_MIN_WIDTH_IN_EN;
    },
    set width(width) {
        if (typeof width === 'number' && width !== Number.NaN) {
            localStorage.setItem(BILL_DRAWER_WIDTH_STORAGE_KEY, width.toString());
        }
    },
    get width() {
        var width = localStorage.getItem(BILL_DRAWER_WIDTH_STORAGE_KEY);
        return width ? parseInt(width) : BILL_DRAWER_DEFAULT_WIDTH;
    }
};
export var flowPartDrawerConfig = {
    minWidth: FLOW_PART_MIN_RESIZE_WIDTH,
    maxWidth: FLOW_PART_MAX_RESIZE_WIDTH,
    listModeDefaultWidth: FLOW_PART_LIST_MODE_DEFAULT_WIDTH,
    tableModeDefaultWidth: FLOW_PART_TABLE_MODE_DEFAULT_WIDTH,
    collapseWidth: i18n.currentLocale === 'zh-CN' ? 52 : 72,
    createStateDefaultWidth: FLOW_PART_CREATE_STATE_DEFAULT_WIDTH
};
export var ELEMENTS_IDS_NOT_CLOSE_BILL_DRAWER = ['ekb-node-openlink', 'ai-approval-copilot-detail-drawer'];
